import React, { Component } from "react";
import { parse } from "qs";
import { Button, Modal, Spin } from "antd";

import { connect } from "dva";
import NormGroup from "../../../components/NormGroup";
import AddNormModal from "../../../Norm/components/AddNormModal";

const { confirm } = Modal;

@connect(({ projectCriterion }) => ({
  normDetail: projectCriterion.normDetail,
  spinProps: projectCriterion.spinProps
}))
class GroupView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      normType: "detail",
      isShowAddModal: false,
      addNormformData: {
        name: "",
        type: ""
      },
      changedGroupValue: {
        changedName: "", // 表单更新后的名字
        changedNumber: "" // 表单更新后的编号
      },
      form: {} // 分组的form
    };
  }

  componentDidMount = () => {
    this.getGroupDetail();
  };

  // 对指标分组内容进行修改时的回调
  onEdit = (number, name, form) => {
    this.setState({
      changedGroupValue: {
        changedName: name,
        changedNumber: number
      },
      form
    });
  };

  // 获取指标分组详情
  getGroupDetail = () => {
    const { dispatch, record } = this.props;
    const { projectId, indexCode, respondentOrgId } = record;
    dispatch({
      type: "projectCriterion/fetchGetDetail",
      payload: {
        indexCode,
        projectId,
        respondentOrgId
      }
    });
  };

  // 获取指标树
  getEvaluateTree = () => {
    const { dispatch, record } = this.props;
    const { projectId,respondentOrgId } = record;
    dispatch({
      type: "tree/getEvaluateTree",
      payload: {
        projectId,
        respondentOrgId
      }
    });
  };

  // 修改指标详情信息
  submitChange = () => {
    const { dispatch, record, normDetail } = this.props;
    const { changedGroupValue, form } = this.state;
    const { projectId, indexCode, respondentOrgId } = record;
    const { validateFields } = form;
    const { name, number } = normDetail;
    const { changedName, changedNumber } = changedGroupValue;
    if (typeof validateFields === "function") {
      validateFields(err => {
        if (!err) {
          dispatch({
            type: "projectCriterion/fetchSetDetail",
            payload: {
              projectId,
              indexCode,
              respondentOrgId,
              numberName: changedNumber,
              indexName: changedName
            },
            callback: [this.getEvaluateTree, this.getGroupDetail]
          });
          this.setState(
            {
              normType: "detail"
            }
          );
        }
      });
    } else {
      dispatch({
        type: "projectCriterion/fetchSetDetail",
        payload: {
          projectId,
          indexCode,
          respondentOrgId,
          numberName: number,
          indexName: name
        },
        callback: [this.getEvaluateTree, this.getGroupDetail]
      });
      this.setState(
        {
          normType: "detail"
        }
      );
    }
  };

  handleEdit = () => {
    this.setState(
      {
        normType: "form"
      }
    );
  };

  handleAddNorm = () => {
    this.setState({
      isShowAddModal: true
    });
  };

  // 删除指标
  handleDeleteNorm = () => {
    const { record, dispatch, renderRoot } = this.props;
    const { projectId, indexCode, respondentOrgId } = record;
    dispatch({
      type: "projectCriterion/fetchDeleteNorm",
      payload: {
        indexCode,
        projectId,
        respondentOrgId
      },
      callback: [this.getEvaluateTree, renderRoot]
    });
  };

  // 新增下级指标
  handleAddNormConfirm = ({ name, number, type }) => {
    const { dispatch, record } = this.props;
    const { projectId, indexCode, respondentOrgId } = record;
    dispatch({
      type: "projectCriterion/fetchAddNorm",
      payload: {
        nodeType: type,
        projectId,
        respondentOrgId,
        parentCode: indexCode,
        numberName: number,
        nodeName: name
      },
      callback: this.getEvaluateTree
    });
    this.setState({
      isShowAddModal: false
    });
  };

  // 显示新增下级指标对话框
  renderAddModal = () => {
    const { isShowAddModal, addNormformData } = this.state;
    const addNormProps = {
      title: "新增下级指标",
      visible: isShowAddModal,
      onCancel: () => this.setState({ isShowAddModal: false }),
      onOk: this.handleAddNormConfirm,
      data: addNormformData
    };
    return <AddNormModal {...addNormProps} />;
  };

  // 显示删除对话框
  renderDeleteModal = () => {
    const deleteProps = {
      title: `删除指标`,
      content: "确定删除选中的指标吗？",
      okText: "确定",
      cancelText: "取消",
      centered: true,
      onOk: this.handleDeleteNorm
    };
    confirm({ ...deleteProps });
    return false;
  };

  render() {
    const { normType } = this.state;
    const { normDetail, spinProps } = this.props;
    return (
      <div>
        <Spin {...spinProps}>
          <div className="header" style={{ marginBottom: 16 }}>
            <Button onClick={this.handleAddNorm} type="primary">
              + 新增下级指标
            </Button>
            {normType === "detail" && (
              <Button onClick={this.handleEdit} type="primary">
                编辑
              </Button>
            )}
            {normType === "form" && (
              <Button onClick={this.renderDeleteModal}>删除指标</Button>
            )}
          </div>
          <NormGroup
            type={normType}
            onEdit={this.onEdit}
            name={normDetail.name}
            number={normDetail.number}
          />
          {normType === "form" && (
            <Button type="primary" onClick={this.submitChange}>
              保存修改
            </Button>
          )}
          {this.renderAddModal()}
        </Spin>
      </div>
    );
  }
}

export default GroupView;
